export async function sendDebugLog(event: string, details: Record<string, unknown>): Promise<void> {
  if (import.meta.env.VITE_APP_ENV !== 'dev') {
    return;
  }

  console.log(`[extension-debug] ${event}`, details);
}
